import { updateEntity } from "actions/entities";
import AppChannels from 'cable.js'
import store from 'store.js'
import { setChannelConnected, setChannelDisconnected} from 'actions/channels'

export default function subscribeSendOnPeppolUpdates(officeSlug) {
    AppChannels.sendOnPeppolUpdates = AppChannels.sendOnPeppolUpdates || {};

    if(!AppChannels.sendOnPeppolUpdates[officeSlug]) {
      AppChannels.sendOnPeppolUpdates[officeSlug] = AppChannels.cable.subscriptions.create({ channel: "SendOnPeppolChannel", slug: officeSlug }, {
        connected: function() {
          store.dispatch(setChannelConnected('send_on_peppol'))
        },

        disconnected: function() {
          store.dispatch(setChannelDisconnected('send_on_peppol'))
        },

        received: function(data) {
          store.dispatch(updateEntity('invoice', { id: data.invoice_id, sendPeppolWarning: data.peppol_warning}))
        }
      });
    }
}
